var _rect, _rect2, _path, _g, _path2, _rect3, _rect4, _path3, _g2, _path4, _path5, _rect5, _path6, _g3, _path7, _rect6, _rect7, _path8, _g4, _path9, _path10, _rect8, _path11, _g5, _path12, _rect9, _rect10, _path13, _g6, _path14, _path15, _rect11, _path16, _g7, _path17, _rect12, _path18, _g8, _path19, _rect13, _path20, _g9, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 219,
    viewBox: "0 0 148 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 218,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 218,
    rx: 9.5,
    stroke: "#668BA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.008 24H13.408V15.216H16.32V13.12H8.096V15.216H11.008V24ZM17.6163 14.464H20.1123V12.448H17.6163V14.464ZM17.6803 24H20.0483V15.648H17.6803V24ZM22.1021 24H24.4701V18.64C24.8381 17.84 25.3021 17.504 25.8621 17.504C26.4381 17.504 26.7741 17.84 26.7741 18.576V24H29.1421V18.64C29.5261 17.84 29.9741 17.504 30.5501 17.504C31.1261 17.504 31.4461 17.84 31.4461 18.576V24H33.8141V18.32C33.8141 16.448 32.8701 15.456 31.1741 15.456C30.1981 15.456 29.4301 15.792 28.7901 16.64C28.3741 15.856 27.6221 15.456 26.5501 15.456C25.5261 15.456 24.7901 15.824 24.1821 16.672L24.1181 15.648H22.1021V24ZM39.3093 24.192C41.5653 24.192 42.7973 23.248 42.8933 21.44H40.6373C40.5893 22.016 40.1253 22.336 39.3253 22.336C38.3013 22.336 37.8693 21.808 37.8693 20.72V20.56H42.9413V19.04C42.9413 16.72 41.6613 15.456 39.2133 15.456C36.7812 15.456 35.5013 16.688 35.5013 19.008V20.64C35.5013 22.992 36.7812 24.192 39.3093 24.192ZM37.8693 18.896C37.8693 17.776 38.2853 17.312 39.2933 17.312C40.2853 17.312 40.7013 17.776 40.7013 18.896H37.8693ZM44.649 24H47.017V19.328C47.241 18.16 47.833 17.696 49.065 17.696H49.513V15.488H48.889C47.737 15.488 47.081 16.016 46.761 17.2L46.665 15.648H44.649V24Z",
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3851_318454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 31H8V71H140V31Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.6274 31L-4 71H55.7587L149 31H88.6274Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.874 31L61 71H67.5169L160 31H152.874Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.829 31H10C8.89543 31 8 31.8954 8 33V71.0779C8 72.1825 8.89543 73.0779 10 73.0779H140.829C141.933 73.0779 142.829 72.1825 142.829 71.0779V33C142.829 31.8954 141.933 31 140.829 31Z",
    stroke: "#031D29",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3611 60.7995C26.8491 60.7995 25.6918 60.3702 24.8891 59.5115C24.0864 58.6529 23.6851 57.4395 23.6851 55.8715V45.5675C23.6851 43.9995 24.0864 42.7862 24.8891 41.9275C25.6918 41.0689 26.8491 40.6395 28.3611 40.6395C29.8731 40.6395 31.0304 41.0689 31.8331 41.9275C32.6358 42.7862 33.0371 43.9995 33.0371 45.5675V55.8715C33.0371 57.4395 32.6358 58.6529 31.8331 59.5115C31.0304 60.3702 29.8731 60.7995 28.3611 60.7995ZM28.3611 57.9995C29.4251 57.9995 29.9571 57.3555 29.9571 56.0675V45.3715C29.9571 44.0835 29.4251 43.4395 28.3611 43.4395C27.2971 43.4395 26.7651 44.0835 26.7651 45.3715V56.0675C26.7651 57.3555 27.2971 57.9995 28.3611 57.9995ZM40.132 60.7995C38.62 60.7995 37.4627 60.3702 36.66 59.5115C35.8574 58.6529 35.456 57.4395 35.456 55.8715V45.5675C35.456 43.9995 35.8574 42.7862 36.66 41.9275C37.4627 41.0689 38.62 40.6395 40.132 40.6395C41.644 40.6395 42.8014 41.0689 43.604 41.9275C44.4067 42.7862 44.808 43.9995 44.808 45.5675V55.8715C44.808 57.4395 44.4067 58.6529 43.604 59.5115C42.8014 60.3702 41.644 60.7995 40.132 60.7995ZM40.132 57.9995C41.196 57.9995 41.728 57.3555 41.728 56.0675V45.3715C41.728 44.0835 41.196 43.4395 40.132 43.4395C39.068 43.4395 38.536 44.0835 38.536 45.3715V56.0675C38.536 57.3555 39.068 57.9995 40.132 57.9995ZM52.4953 46.8835H55.4633V49.8515H52.4953V46.8835ZM52.4953 57.5515H55.4633V60.5195H52.4953V57.5515ZM67.8291 60.7995C66.3171 60.7995 65.1597 60.3702 64.3571 59.5115C63.5544 58.6529 63.1531 57.4395 63.1531 55.8715V45.5675C63.1531 43.9995 63.5544 42.7862 64.3571 41.9275C65.1597 41.0689 66.3171 40.6395 67.8291 40.6395C69.3411 40.6395 70.4984 41.0689 71.3011 41.9275C72.1037 42.7862 72.5051 43.9995 72.5051 45.5675V55.8715C72.5051 57.4395 72.1037 58.6529 71.3011 59.5115C70.4984 60.3702 69.3411 60.7995 67.8291 60.7995ZM67.8291 57.9995C68.8931 57.9995 69.4251 57.3555 69.4251 56.0675V45.3715C69.4251 44.0835 68.8931 43.4395 67.8291 43.4395C66.7651 43.4395 66.2331 44.0835 66.2331 45.3715V56.0675C66.2331 57.3555 66.7651 57.9995 67.8291 57.9995ZM79.6 60.7995C78.088 60.7995 76.9307 60.3702 76.128 59.5115C75.3253 58.6529 74.924 57.4395 74.924 55.8715V45.5675C74.924 43.9995 75.3253 42.7862 76.128 41.9275C76.9307 41.0689 78.088 40.6395 79.6 40.6395C81.112 40.6395 82.2693 41.0689 83.072 41.9275C83.8747 42.7862 84.276 43.9995 84.276 45.5675V55.8715C84.276 57.4395 83.8747 58.6529 83.072 59.5115C82.2693 60.3702 81.112 60.7995 79.6 60.7995ZM79.6 57.9995C80.664 57.9995 81.196 57.3555 81.196 56.0675V45.3715C81.196 44.0835 80.664 43.4395 79.6 43.4395C78.536 43.4395 78.004 44.0835 78.004 45.3715V56.0675C78.004 57.3555 78.536 57.9995 79.6 57.9995ZM91.9633 46.8835H94.9313V49.8515H91.9633V46.8835ZM91.9633 57.5515H94.9313V60.5195H91.9633V57.5515ZM107.297 60.7995C105.785 60.7995 104.628 60.3702 103.825 59.5115C103.022 58.6529 102.621 57.4395 102.621 55.8715V45.5675C102.621 43.9995 103.022 42.7862 103.825 41.9275C104.628 41.0689 105.785 40.6395 107.297 40.6395C108.809 40.6395 109.966 41.0689 110.769 41.9275C111.572 42.7862 111.973 43.9995 111.973 45.5675V55.8715C111.973 57.4395 111.572 58.6529 110.769 59.5115C109.966 60.3702 108.809 60.7995 107.297 60.7995ZM107.297 57.9995C108.361 57.9995 108.893 57.3555 108.893 56.0675V45.3715C108.893 44.0835 108.361 43.4395 107.297 43.4395C106.233 43.4395 105.701 44.0835 105.701 45.3715V56.0675C105.701 57.3555 106.233 57.9995 107.297 57.9995ZM119.068 60.7995C117.556 60.7995 116.399 60.3702 115.596 59.5115C114.793 58.6529 114.392 57.4395 114.392 55.8715V45.5675C114.392 43.9995 114.793 42.7862 115.596 41.9275C116.399 41.0689 117.556 40.6395 119.068 40.6395C120.58 40.6395 121.737 41.0689 122.54 41.9275C123.343 42.7862 123.744 43.9995 123.744 45.5675V55.8715C123.744 57.4395 123.343 58.6529 122.54 59.5115C121.737 60.3702 120.58 60.7995 119.068 60.7995ZM119.068 57.9995C120.132 57.9995 120.664 57.3555 120.664 56.0675V45.3715C120.664 44.0835 120.132 43.4395 119.068 43.4395C118.004 43.4395 117.472 44.0835 117.472 45.3715V56.0675C117.472 57.3555 118.004 57.9995 119.068 57.9995Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 75,
    width: 38.6667,
    height: 98,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 81,
    width: 31,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3335 81V111H12.3335L42.3335 81Z",
    fill: "#FAAC48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7451 97.3844L27.471 88.9412V93.7333L16.7451 102.176V97.3844ZM37.9216 97.3844L27.471 88.9412V93.7333L37.9216 102.176V97.3844Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9143 129H20.1743V124.716H24.7803V129H26.0403V119.48H24.7803V123.54H20.1743V119.48H18.9143V129ZM28.6213 129H29.8813V124.716H34.4873V129H35.7473V119.48H34.4873V123.54H29.8813V119.48H28.6213V129Z",
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 137,
    width: 31,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3335 137V167H12.3335L42.3335 137Z",
    fill: "#FAAC48"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9219 149.733L27.196 158.177L27.196 153.384L37.9219 144.941L37.9219 149.733ZM16.7454 149.733L27.196 158.177L27.196 153.384L16.7454 144.941L16.7454 149.733Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6665,
    y: 75,
    width: 38.6667,
    height: 98,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 81,
    width: 30,
    height: 30
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89 81V111H59L89 81Z",
    fill: "#FAAC48"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4116 97.3844L74.1375 88.9412V93.7333L63.4116 102.176V97.3844ZM84.5881 97.3844L74.1375 88.9412V93.7333L84.5881 102.176V97.3844Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2019 129H64.4199V121.076L67.4859 129H68.3959L71.4479 121.104V129H72.7079V119.48H70.8319L67.9619 126.956L65.0919 119.48H63.2019V129ZM75.2878 129H76.5058V121.076L79.5718 129H80.4818L83.5338 121.104V129H84.7938V119.48H82.9178L80.0478 126.956L77.1778 119.48H75.2878V129Z",
    fill: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 137,
    width: 30,
    height: 30
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89 137V167H59L89 137Z",
    fill: "#FAAC48"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5884 149.733L73.8625 158.177L73.8625 153.384L84.5884 144.941L84.5884 149.733ZM63.4119 149.733L73.8625 158.177L73.8625 153.384L63.4119 144.941L63.4119 149.733Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101.333,
    y: 75,
    width: 38.6667,
    height: 98,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 81,
    width: 31,
    height: 30
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.667 81V111H105.667L135.667 81Z",
    fill: "#FAAC48"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 82,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.079 97.3844L120.804 88.9412V93.7333L110.079 102.176V97.3844ZM131.255 97.3844L120.805 88.9412V93.7333L131.255 102.176V97.3844Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.74 129.168C118.966 129.168 120.086 128.244 120.086 126.382C120.086 124.646 119.218 123.862 116.922 123.568C115.312 123.358 114.724 122.91 114.724 121.958C114.724 120.992 115.438 120.46 116.74 120.46C118.056 120.46 118.686 120.992 118.686 122.098H119.946C119.946 120.236 118.882 119.312 116.782 119.312C114.64 119.312 113.478 120.264 113.478 122.084C113.478 123.722 114.29 124.464 116.474 124.758C118.224 124.996 118.84 125.472 118.84 126.494C118.84 127.502 118.14 128.02 116.754 128.02C115.312 128.02 114.57 127.446 114.57 126.298H113.31C113.31 128.216 114.472 129.168 116.74 129.168ZM124.656 129.168C126.882 129.168 128.002 128.244 128.002 126.382C128.002 124.646 127.134 123.862 124.838 123.568C123.228 123.358 122.64 122.91 122.64 121.958C122.64 120.992 123.354 120.46 124.656 120.46C125.972 120.46 126.602 120.992 126.602 122.098H127.862C127.862 120.236 126.798 119.312 124.698 119.312C122.556 119.312 121.394 120.264 121.394 122.084C121.394 123.722 122.206 124.464 124.39 124.758C126.14 124.996 126.756 125.472 126.756 126.494C126.756 127.502 126.056 128.02 124.67 128.02C123.228 128.02 122.486 127.446 122.486 126.298H121.226C121.226 128.216 122.388 129.168 124.656 129.168Z",
    fill: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 137,
    width: 31,
    height: 30
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.667 137V167H105.667L135.667 137Z",
    fill: "#FAAC48"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 138,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.255 149.733L120.529 158.177L120.529 153.384L131.255 144.941L131.255 149.733ZM110.079 149.733L120.529 158.177L120.529 153.384L110.079 144.941L110.079 149.733Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 178,
    width: 62,
    height: 32,
    rx: 3.5,
    fill: "#830D2A",
    stroke: "#620A1F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 177,
    width: 64,
    height: 42
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 177V184V219H15V211H8L15 204V184H65L72 177Z",
    fill: "#C4C4C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 178,
    width: 62,
    height: 32,
    rx: 3.5,
    stroke: "#620A1F",
    strokeWidth: 2
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8706 200.192C30.5906 200.192 31.9186 199.088 31.9186 196.832C31.9186 194.784 31.0386 193.808 28.4946 193.44C26.9586 193.216 26.3986 192.848 26.3986 192.032C26.3986 191.312 26.9106 190.896 27.9026 190.896C28.9426 190.896 29.4386 191.36 29.4386 192.304H31.7746C31.7746 190.016 30.5106 188.928 27.9506 188.928C25.3586 188.928 23.9986 190.048 23.9986 192.272C23.9986 194.256 24.9106 195.152 27.3266 195.536C28.9426 195.792 29.5186 196.176 29.5186 197.072C29.5186 197.856 28.9906 198.24 27.9346 198.24C26.7666 198.24 26.1746 197.776 26.1746 196.72H23.8386C23.8386 199.104 25.1026 200.192 27.8706 200.192ZM36.276 200H38.02V198.144H37.092C36.404 198.144 36.212 197.92 36.212 197.136V193.44H37.94V191.648H36.212V189.568H34.02L33.892 191.648H32.628V193.44H33.844V197.28C33.844 199.2 34.564 200 36.276 200ZM42.8245 200.192C45.3525 200.192 46.6165 198.992 46.6165 196.592V195.056C46.6165 192.656 45.3525 191.456 42.8245 191.456C40.2965 191.456 39.0325 192.656 39.0325 195.056V196.592C39.0325 198.992 40.2965 200.192 42.8245 200.192ZM42.8245 198.272C41.8165 198.272 41.4005 197.76 41.4005 196.544V195.104C41.4005 193.888 41.8165 193.376 42.8245 193.376C43.8325 193.376 44.2485 193.888 44.2485 195.104V196.544C44.2485 197.76 43.8325 198.272 42.8245 198.272ZM48.3678 202.912H50.7358V199.328C51.2958 199.92 51.9998 200.192 52.8958 200.192C54.7998 200.192 55.8718 199.008 55.8718 196.752V194.88C55.8718 192.624 54.7998 191.456 52.8958 191.456C51.8398 191.456 51.0718 191.824 50.4478 192.656L50.3838 191.648H48.3678V202.912ZM52.3518 198.272C51.5998 198.272 51.0718 197.84 50.7358 196.992V194.64C51.0718 193.808 51.5998 193.376 52.3358 193.376C53.1038 193.376 53.5038 193.824 53.5038 194.896V196.752C53.5038 197.84 53.1038 198.272 52.3518 198.272Z",
    fill: "#BBBBBB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 178,
    width: 62,
    height: 32,
    rx: 4,
    fill: "#FAAC48",
    stroke: "#FCCD91",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3851_318454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 177,
    width: 64,
    height: 42
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 177V184V219H83V211H76L83 204V184H133L140 177Z",
    fill: "#C4C4C4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3851_318454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 178,
    width: 62,
    height: 32,
    rx: 4,
    stroke: "#E19B41",
    strokeWidth: 2
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3067 198.668C98.6867 198.668 99.8487 197.702 99.8487 195.728C99.8487 193.936 99.0787 193.082 96.8527 192.76C95.5087 192.564 95.0187 192.242 95.0187 191.528C95.0187 190.898 95.4667 190.534 96.3347 190.534C97.2447 190.534 97.6787 190.94 97.6787 191.766H99.7227C99.7227 189.764 98.6167 188.812 96.3767 188.812C94.1087 188.812 92.9187 189.792 92.9187 191.738C92.9187 193.474 93.7167 194.258 95.8307 194.594C97.2447 194.818 97.7487 195.154 97.7487 195.938C97.7487 196.624 97.2867 196.96 96.3627 196.96C95.3407 196.96 94.8227 196.554 94.8227 195.63H92.7787C92.7787 197.716 93.8847 198.668 96.3067 198.668ZM103.661 198.5H105.187V196.876H104.375C103.773 196.876 103.605 196.68 103.605 195.994V192.76H105.117V191.192H103.605V189.372H101.687L101.575 191.192H100.469V192.76H101.533V196.12C101.533 197.8 102.163 198.5 103.661 198.5ZM108.325 198.668C109.291 198.668 110.019 198.304 110.523 197.59L110.593 198.5H112.343V193.796C112.343 191.892 111.391 191.024 109.319 191.024C107.303 191.024 106.323 191.85 106.211 193.474H108.213C108.241 192.97 108.521 192.648 109.235 192.648C109.977 192.648 110.271 193.012 110.271 193.768V194.006H108.927C106.981 194.006 106.015 194.86 106.015 196.4C106.015 197.856 106.883 198.668 108.325 198.668ZM108.955 197.044C108.367 197.044 108.059 196.764 108.059 196.232C108.059 195.7 108.367 195.378 109.305 195.378H110.271V196.218C109.977 196.764 109.543 197.044 108.955 197.044ZM114.037 198.5H116.109V194.412C116.305 193.39 116.823 192.984 117.901 192.984H118.293V191.052H117.747C116.739 191.052 116.165 191.514 115.885 192.55L115.801 191.192H114.037V198.5ZM121.859 198.5H123.385V196.876H122.573C121.971 196.876 121.803 196.68 121.803 195.994V192.76H123.315V191.192H121.803V189.372H119.885L119.773 191.192H118.667V192.76H119.731V196.12C119.731 197.8 120.361 198.5 121.859 198.5Z",
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3851_318454"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 132,
    height: 40,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerSmall);
export default __webpack_public_path__ + "static/media/Timer_Small.cf766059b3acced8d935cac781491006.svg";
export { ForwardRef as ReactComponent };